/**
 * Host-independent security console configuration.
 *
 * The admin dashboard talks to a single configurable endpoint served by your
 * own PHP or Node backend (see src/backend/). Nothing here points at any
 * third-party or platform service, so the built site works on any host.
 *
 *   VITE_PUBLIC_SECURITY_ENDPOINT -> where the admin console POSTs
 *                                    (default "/security.php")
 *
 * IMPORTANT: no secret is stored here. The admin key is typed by the operator
 * on the dashboard and kept only in sessionStorage for that browser tab; the
 * real key lives on the server (see SECURITY_ADMIN_KEY in your config file).
 */

const rawEndpoint = import.meta.env.VITE_PUBLIC_SECURITY_ENDPOINT as string | undefined;

/** Endpoint the admin console submits to. Override with VITE_PUBLIC_SECURITY_ENDPOINT. */
export const SECURITY_ENDPOINT =
  typeof rawEndpoint === "string" && rawEndpoint.trim().length > 0
    ? rawEndpoint.trim()
    : "/security.php";

/** Header used to pass the operator's admin key to the backend. */
export const SECURITY_KEY_HEADER = "X-Security-Key";

/** sessionStorage key for the operator's admin key (tab-scoped, never persisted long term). */
export const SECURITY_KEY_STORAGE = "lahari_admin_security_key";